import { render, staticRenderFns } from "./ButtonComponent.vue?vue&type=template&id=8eac3d2e&"
import script from "./ButtonComponent.vue?vue&type=script&lang=js&"
export * from "./ButtonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports